/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_MODE = "COMMENTS" | "QA" | "RATINGS_AND_REVIEWS" | "%future added value";
export type FeaturedCommentContainer_story = {
    readonly url: string;
    readonly commentCounts: {
        readonly tags: {
            readonly FEATURED: number;
        };
    };
    readonly settings: {
        readonly mode: STORY_MODE;
    };
    readonly " $fragmentRefs": FragmentRefs<"UserTagsContainer_story">;
    readonly " $refType": "FeaturedCommentContainer_story";
};
export type FeaturedCommentContainer_story$data = FeaturedCommentContainer_story;
export type FeaturedCommentContainer_story$key = {
    readonly " $data"?: FeaturedCommentContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeaturedCommentContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "CommentCounts",
            "kind": "LinkedField",
            "name": "commentCounts",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentTagCounts",
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "FEATURED",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mode",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserTagsContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '89d74932440abcd8ff3cefeb2f65984a';
export default node;
